import { Navigate } from 'react-router-dom';
import { Unauthorized } from '../Components/Unauthorized';

const ProtectedRoute = ({ element, routeName }) => {
  const token = localStorage.getItem('token');
  // const permissions = JSON.parse(localStorage.getItem("user_permissions"));

  // const isAuthorized = permissions?.some((route) => route.privilege_description === routeName && route.privilege_view === 1);
  // if (!isAuthorized) return <Unauthorized />;

  return token ? element : <Navigate to="/Login" />;
};

export default ProtectedRoute